import { JourneyRoute } from '@cash-web/shared-journey-data-access-context'

export const savingsJourneyRoutes = [
  {
    id: 'savings-transfer-in',
    trackingName: 'Savings Transfer In',
    path: 'savings/transfer-cash/to-savings/:transferContext',
    lazy: async () => ({
      Component: (await import('../components/JourneySavingsTransfer')).JourneySavingsTransferIn,
    }),
  },
  {
    id: 'savings-transfer-in-goal',
    trackingName: 'Savings Transfer In From Goal',
    path: 'savings/transfer-cash/to-savings/goal/:goalToken',
    lazy: async () => ({
      Component: (await import('../components/JourneySavingsTransfer')).JourneySavingsTransferInFromGoal,
    }),
  },
  {
    id: 'savings-transfer-out',
    trackingName: 'Savings Transfer Out',
    path: 'savings/transfer-cash/from-savings/:transferContext',
    lazy: async () => ({
      Component: (await import('../components/JourneySavingsTransfer')).JourneySavingsTransferOut,
    }),
  },
  {
    id: 'savings-transfer-out-goal',
    trackingName: 'Savings Transfer In From Goal',
    path: 'savings/transfer-cash/from-savings/goal/:goalToken',
    lazy: async () => ({
      Component: (await import('../components/JourneySavingsTransfer')).JourneySavingsTransferOutFromGoal,
    }),
  },
  {
    id: 'savings-folder-default',
    trackingName: 'Default Savings Folder',
    path: 'savings/folder/default',
    lazy: async () => ({
      Component: (await import('../components/JourneySavingsFolder')).JourneySavingsDefaultFolder,
    }),
  },
  {
    id: 'savings-folder-goal',
    trackingName: 'Default Savings Folder Goal',
    path: 'savings/goal/:goalToken',
    lazy: async () => ({
      Component: (await import('../components/JourneySavingsFolder')).JourneySavingsGoalFolder,
    }),
  },
  {
    id: 'savings-activity',
    trackingName: 'Savings Activity',
    path: 'savings/activity',
    lazy: async () => ({
      Component: (await import('../components/JourneySavingsActivity')).JourneySavingsActivity,
    }),
  },
  {
    id: 'savings-activity-filtered',
    trackingName: 'Savings Activity Filtered',
    path: 'savings/activity/:subToken',
    lazy: async () => ({
      Component: (await import('../components/JourneySavingsActivity')).JourneySavingsActivity,
    }),
  },
  {
    id: 'savings-activity-item',
    trackingName: 'Savings Activity Item',
    path: 'savings/activity/item/:token',
    modalVariant: 'receipt',
    lazy: async () => ({
      Component: (await import('../components/JourneySavingsActivityItem')).JourneySavingsActivityItem,
    }),
  },
] as const satisfies JourneyRoute[]
